import { Seo } from '../components/Seo';
import { Link } from "react-router-dom";
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

import { pressData } from '../data/press'
import './Press.css';

const Press = () => {

    // get all the news titles and use them as the page description
    let press_descr = "";
    pressData.map((data, key) => (
        press_descr = press_descr + data.title + "; "
    ));


    return (
        <>

            <Seo
                title="Schwabe Enterprises - AI Development, Engineering, Consulting, Advanced Data Science, Tech Incubator"
                description="Schwabe Enterprises is a leading provider of AI development, engineering, consulting, advanced data science, and tech incubator services."
                type="webapp"
            />
            <Header selectedNavitem="press" />

            <div className="container py-5">
                <div className="text-center mb-5">
                    <h1 className="display-5 fw-bold mb-3">Press and Media</h1>
                    <div className="d-none">{press_descr}</div>

                    <p className="lead text-muted">
                        For media inquiries, please contact: <br />
                        <Link to="mailto:press@schwabe.net" className="text-decoration-none">press@schwabe.net</Link><br />
                        <span className="fs-6">tel: +1 610-721-0328</span>
                    </p>
                </div>

                <div className="row justify-content-center g-4">

                    {pressData.map((data, key) => {
                        return (
                            <div key={key} className="col-lg-5 press_feature position-relative">
                                <div className="press_media_type badge bg-primary mb-2">{data.type}</div>
                                <div className="press_img_wrapper shadow-sm rounded overflow-hidden mb-3">
                                    <img className="press_img w-100" alt={data.title} src={data.img} />
                                </div>
                                <div className="press_text">
                                    <div className="press_date text-muted small mb-2">{data.date}</div>
                                    <div className="press_title">
                                        <p className="fw-bold h5 mb-2">{data.title}</p>
                                        {data.links.map((link, i) => (
                                            <div key={i}>
                                                <a className="btn btn-sm btn-outline-primary mt-2"
                                                    href={link.uri}
                                                    target="_blank" rel="noopener noreferrer"
                                                >{link.name}</a><br />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        );
                    })}

                </div>
            </div>

            <Footer />

        </>
    )
};

export default Press;